import type { IHTTPResponse } from '@/store/core/api/APIResult.ts'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import type { BaseQueryFn } from '@reduxjs/toolkit/query/react'
import axios from 'axios'
import type { AxiosError, AxiosRequestConfig } from 'axios'

export const axiosBaseQuery =
	(
		{ baseUrl }: { baseUrl: string } = { baseUrl: '/api' },
	): BaseQueryFn<
		{
			url: string
			method: AxiosRequestConfig['method']
			data?: AxiosRequestConfig['data']
			params?: AxiosRequestConfig['params']
			headers?: AxiosRequestConfig['headers']
		},
		unknown,
		FetchBaseQueryError
	> =>
	async ({ url, method, data, params, headers }) => {
		try {
			const result = await axios.request<IHTTPResponse<any>>({
				url: baseUrl + url,
				method,
				data,
				params,
				headers,
			})

			return {
				data: result.data,
				meta: {
					//totalCount: parseInt(result.headers['x-pagination-total']),
				},
			}
		} catch (axiosError) {
			const err = axiosError as AxiosError
			return {
				error: {
					status: err.response?.status,
					data: err.response?.data || err.message,
				} as FetchBaseQueryError,
			}
		}
	}
